import { render, staticRenderFns } from "./OrderItemsEditor.vue?vue&type=template&id=410b79de&scoped=true&"
import script from "./OrderItemsEditor.vue?vue&type=script&lang=js&"
export * from "./OrderItemsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410b79de",
  null
  
)

export default component.exports